module.exports = __webpack_public_path__ + "img/img_mainland_account_open_9.d5b2be07.png";